<script>
  import {
    cart,
    clearCart,
    myOrder,
    saveCart,
    orderOnLogin,
    business,
    loyaltyRules,
    userDetails,
  } from "../stores";
  import { loadLocalFile } from "../file-service.js";
  import * as OrderBL from "../bl/order-bl";
  import * as BusinessBL from "../bl/business-bl";
  import MyOrder from "./MyOrder.svelte";
  import CartItem from "./CartItem.svelte";
  import * as InitService from "../bl/init-service";
  import { push, pop } from "svelte-spa-router";
  import LoadingAnim from "./LoadingAnim.svelte";
  import { calcCartPrice } from "../../functions/module/price-service";
  import { onDestroy } from "svelte";
  import AutoComplete from "simple-svelte-autocomplete";
  import FaArrowLeft from "svelte-icons/fa/FaArrowLeft.svelte";
  import { isBusinessOpen } from "../utils.js";

  //  under the order object: save in each order a pointer to the id of the loyaltyRule it has stamped, if any
  //  under the user object: save map of loyaltyRuleId and current number of stamps that have not been rewarded yet
  //  user/stamps subcollection: all order ids that have given a stamp, and on which date was the reward given (if ever), and which order id of the reward

  let sum = 0;

  let city;
  let loadedCityCode;
  let street;
  let streetNumber;
  let streets = [];
  let legalCities = [];

  let showTakeaway = false;
  let showDelivery = false;

  let gettingUrl = false;

  let formValid = false;

  function validateAddress() {
    formValid =
      city && street && Number.isInteger(+streetNumber) && +streetNumber;
  }

  async function loadCityStreets(cityCode) {
    if (cityCode == loadedCityCode) return;

    const url = `csv/cities/${cityCode}.csv`;
    const response = window.cordova
      ? await loadLocalFile(url)
      : await fetch(url);
    const text = window.cordova ? response : await response.text();

    streets = text.split("\n");
    loadedCityCode = cityCode;
  }

  $: {
    if ($business) {
      if ($business.deliverySettings && $business.deliverySettings.enabled) {
        legalCities = $business.deliverySettings.cities;
      }
    } else {
      InitService.onInitComplete(() => {
        if ($cart.details.code) BusinessBL.getBusiness($cart.details.code);
      });
    }
  }

  $: {
    console.log('in cart.svelte reactive code')
    console.log('cart:')
    console.log($cart)
    console.log('business:')
    console.log($business)
    console.log('loyaltyRules:')
    console.log($loyaltyRules)
    if ($cart && $business && $loyaltyRules) {
      if ($cart.items) {
        let res = calcCartPrice(
          $cart,
          $userDetails?.loyaltyCards,
          $loyaltyRules
        );
        sum = res.sum;
        $cart = res.cart;
      }
      saveCart();
    }
  }

  onDestroy(() => {
    $orderOnLogin = false;
  });

  $: isOpen = isBusinessOpen($business);

</script>

{#if $myOrder}
  <MyOrder on:gotoPayment={OrderBL.gotoPayment} />
{:else if $cart.details.title}
  <main>
    <div class="title">
      {$cart.details.title}
      {#if isOpen}
        <span class="open">פתוח</span>
      {:else}<span class="closed">סגור</span>{/if}
    </div>
    {#each Object.values($cart.items) as item}
      <CartItem {item} showRemoveBtn={true} itemStyle={'cart'} />
    {/each}

    {#if showDelivery && $business?.deliverySettings?.enabled}
      <div class="deliveryPrice">
        <div class="deliveryCartItem">
          <div class="name">משלוח:</div>
          <hr />
          <span> {$business.deliverySettings.price} ₪</span>
        </div>
        <div class="total">
          סה"כ:
          {sum + $business.deliverySettings.price}<span>₪</span>
        </div>
      </div>
    {:else}
      <div class="total">סה"כ: {sum}<span>₪</span></div>
    {/if}

    {#if $business?.deliverySettings?.enabled && !showDelivery && !showTakeaway}
      <div class="deliveryOrTakeaway">
        <button
          class="takeawayBtn"
          class:disabled={!isOpen}
          disabled={!isOpen}
          on:click={() => {
            showTakeaway = true;
            showDelivery = false;
          }}
        >איסוף עצמי</button>
        <button
          class="deliveryBtn"
          class:disabled={!$business?.deliverySettings?.enabled || sum == 0 || !isOpen}
          disabled={!isOpen}
          on:click={() => {
            showDelivery = true;
            showTakeaway = false;
          }}
        >משלוח
          {#if $business?.deliverySettings?.enabled}
            <div class="deliveryPrice">
              ({$business.deliverySettings.price || '0'}₪)
            </div>
          {/if}
        </button>
      </div>
    {:else if showDelivery}
      <AutoComplete
        inputId={'selectCityInput'}
        hideArrow="true"
        items={legalCities}
        bind:selectedItem={city}
        labelFieldName="name"
        maxItemsToShowInList="10"
        placeholder="עיר"
        onChange={(val) => {
          console.log('onChange');
          console.log(val);
          if (!val) return;
          loadCityStreets(val.id);
          street = null;
          validateAddress();
        }}
        itemFilterFunction={(item, query) => {
          query = query.join(' ');
          return item.name.startsWith(query);
        }}
        onBlur={(e) => {
          let input = document.getElementById('selectCityInput');
          if (city?.name) input.value = city.name;
          else input.value = '';
        }}
      />
      <div class="streetAndNumber">
        <AutoComplete
          hideArrow="true"
          items={streets}
          maxItemsToShowInList="10"
          bind:selectedItem={street}
          itemFilterFunction={(item, query) => {
            query = query.join(' ');
            return item.startsWith(query);
          }}
          placeholder="רחוב"
          onChange={validateAddress}
          inputId={'selectStreetInput'}
          onBlur={(e) => {
            let input = document.getElementById('selectStreetInput');
            if (street) input.value = street;
            else input.value = '';
          }}
        />
        <input
          autocapitalize="characters"
          type="text"
          bind:value={streetNumber}
          placeholder="מספר בית"
          class="streetNumber"
          on:input={validateAddress}
        />
      </div>
      <div class="notes">
        <textarea placeholder="הערות" bind:value={$cart.details.notes} />
      </div>
      <div class="buttons">
        <button
          class="width100"
          on:click={() => {
            OrderBL.order({ city, street, streetNumber });
          }}
          class:disabled={!formValid || !isOpen}
          disabled={!formValid || !isOpen}
        >
          הזמן - משלוח
        </button>
        <button
          class="clear1"
          on:click={() => {
            showDelivery = false;
            showTakeaway = false;
          }}
        ><div class="backArrow">
            <FaArrowLeft />
          </div></button>
      </div>
    {:else if showTakeaway || !$business?.deliverySettings?.enabled}
      <div class="notes">
        <textarea placeholder="הערות" bind:value={$cart.details.notes} />
      </div>
      <div class="buttons">
        <button
          class:width85={$business?.deliverySettings?.enabled}
          class:width100={!$business?.deliverySettings?.enabled}
          class:disabled={!isOpen}
          disabled={!isOpen}
          on:click={() => {
            OrderBL.order();
          }}
        >
          הזמן - איסוף עצמי
        </button>
        {#if $business?.deliverySettings?.enabled}
          <button
            class="clear1"
            on:click={() => {
              showDelivery = false;
              showTakeaway = false;
            }}
          >
            <div class="backArrow">
              <FaArrowLeft />
            </div>
          </button>
        {/if}
      </div>
    {/if}
  </main>
  <div
    class="backToMenu"
    on:click={() => {
      push('/b/' + $cart.details.code);
    }}
  >
    <img src="images/arrow.svg" alt="back to menu icon" />
    <span>חזרה לתפריט</span>
  </div>

  {#if gettingUrl}
    <div class="gettingUrl">
      <LoadingAnim />
    </div>
  {/if}
{:else}
  <div class="empty">
    <div class="emptyBg">
      <span>הזמנה ריקה</span>
      <img src="images/logo_white.svg" alt="הזמנה ריקה" />
    </div>
  </div>
{/if}

<style>
  .open {
    color: var(--green1);
    border: 3px solid;
    padding: 1px 10px 3px 10px;
    border-radius: 100px;
    font-size: 24px;
  }

  .closed {
    color: var(--red1);
    border: 3px solid;
    padding: 1px 10px 3px 10px;
    border-radius: 100px;
    font-size: 24px;
  }
  .deliveryCartItem {
    display: flex;
    align-items: center;
    margin-right: 70px;
    margin-left: 25px;
    font-size: 16px;
    margin-bottom: 40px;
  }
  .deliveryCartItem > .name {
    display: list-item;
  }

  .deliveryCartItem > hr {
    width: 100%;
    border: none;
    border-bottom: 4px dotted gray;
    margin-left: 12px;
    margin-right: 12px;
    flex-grow: 1;
    min-width: 30px;
    height: 0px;
  }

  .deliveryCartItem > span {
    min-width: fit-content;
    font-weight: normal;
  }
  .deliveryPrice {
    font-size: 16px;
    margin-top: 6px;
  }
  .takeawayBtn {
    background: var(--green1);
  }
  .notes {
    margin-top: 20px;
  }
  .backArrow {
    width: 24px;
    height: 24px;
    margin-right: auto;
    margin-left: 10px;
  }

  .deliveryOrTakeaway {
    display: flex;
    justify-content: space-evenly;
    margin-top: 20px;
    margin-bottom: 20px;
    flex-wrap: wrap;
    font-size: 20px;
  }

  .deliveryOrTakeaway > button {
    width: 100%;
    height: 40px;
    border-radius: 4px;
    margin: 5px;
  }

  .streetAndNumber {
    display: flex;
  }
  .streetNumber {
    width: 50%;
    margin-right: 6px;
    height: 1.95em;
  }

  .disabled {
    opacity: 0.5;
    pointer-events: none;
    background: #a0a0a0;
  }
  main {
    width: 100%;
    max-width: 440px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    direction: rtl;
    background: white;
    padding: 10px;
    border-radius: 4px;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
    font-family: "Rubik";
    box-shadow: 0px 10px 80px -50px #000000a6;
  }

  .title {
    font-size: 30px;
    margin: 10px;
    margin-bottom: 30px;
    margin-right: 20px;
  }

  span {
    font-size: 18px;
    font-weight: 500;
    margin-right: 5px;
  }

  .buttons {
    font-size: 20px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }
  .width85 {
    width: 85%;
  }

  .width100 {
    width: 100%;
  }
  button {
    border: none;
    color: #fff;
    background-color: var(--blue1);
    outline: none;
    border-radius: 3px;
    margin: 2px;
    cursor: pointer;
  }

  .clear1 {
    background-color: var(--red1);
    width: 25%;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-size: 24px;
    margin-top: 10px;
    margin-bottom: 20px;
    margin-right: auto;
    margin-left: auto;
    font-weight: 500;
    color: var(--grey1);
  }

  textarea {
    width: 100%;
    border-radius: 3px;
    resize: none;
    padding: 10px;
    color: #585858;
    font-family: "Rubik";
    font-size: 17px;
    outline: none;
  }

  textarea:focus {
    border: 1px solid #ccc;
  }

  .empty {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .emptyBg {
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    direction: rtl;
    padding: 30px;
    border-radius: 3px;
    margin: 10px;
    box-shadow: 0 10px 20px -15px;
  }

  .emptyBg > span {
    font-size: 50px;
    font-family: "Rubik";
    margin-left: 40px;
  }
  .emptyBg > img {
    filter: brightness(0.5);
    width: 80px;
  }

  .backToMenu {
    margin-left: auto;
    margin-right: auto;
    display: block;
    background: white;
    max-width: 220px;
    margin-top: 30px;
    padding: 10px;
    font-size: 20px;
    font-family: "Rubik";
    text-align: right;
    border-radius: 3px;
    display: flex;
    flex-flow: row-reverse;
    align-items: center;
    cursor: pointer;
  }

  .backToMenu > img {
    height: 16px;
    margin: 8px;
    position: absolute;
  }

  .backToMenu > span {
    padding-right: 20px;
    padding-left: 20px;
    font-size: 20px;
    font-weight: 500;
    margin-right: 5px;
    width: 100%;
    text-align: center;
  }

  .gettingUrl {
    background: #0005;
    width: 100%;
    height: calc(100vh - var(--nav-bar-height));
    align-items: center;
    justify-content: center;
    position: fixed;
    display: flex;
    top: var(--nav-bar-height);
  }

  @media only screen and (max-width: 500px) {
    main {
      max-width: unset;
      margin: 0;
    }
  }

</style>
